export function isDefined<T>(x: T | undefined | null): x is T {
  return x !== null && typeof x !== 'undefined';
}

export type ExcludesFalse = <T>(x: T | false) => x is T;
